import React, { Component } from 'react';
// import InputField from '../../components/global/InputField.js';
// import Button from '../../global/Button';
import { userPreferencesUpdated, getLocaleTranslationData } from '../../../actions';
import CelaneseAPI from '../../../services';
import './userpreference.css';
import { connect } from 'react-redux';
import { Modal, message } from 'antd';
import PropTypes from 'prop-types';
import Translation from '../../../Translation';
import config from '../../../config';
import { utils } from '../../../config';

var preferenceState = {
    'size': 1,
    'epd': 1,
    'weight': 1,
    'pz': 1,
    'rodMaker': 3,
    'transportJet': 3,
    'towType': 1,
    'kretek': 0,
    'epdBias': '',
    'firmnessMethod': '',
    'pivmaxlim': 1,
    'lowpdlim': 1,
    'epdSel': -1,
    'epdBiasData': {}
};

/**
 * Class for user preferences.
 *
 * @class UserPreference
 * @extends {React.Component}
 */
class UserPreference extends Component {
    constructor(props) {
        super(props);

        this.state = {
            'isSaving': false,
            'size': 1,
            'epd': 1,
            'weight': 1,
            'pz': 1,
            'rodMaker': 1,
            'transportJet': 1,
            'towType': 1,
            'kretek': 0,
            'epdBias': '',
            'firmnessMethod': '',
            'pivmaxlim': 1,
            'lowpdlim': 1,
            'epdValues': '',
            'firmnessValues': [{
                value: 'Filtrona FTS',
                key: 'txt_filtrona_fts'
            }, {
                value: 'Filtrona QTM',
                key: 'txt_filtrona_qtm'
            }, {
                value: 'Filtrona DHT',
                key: 'txt_filtrona_dht'
            }, {
                value: 'Borgwaldt',
                key: 'txt_borgwaldt'
            }, {
                value: 'Borgwaldt w/1 kg wt',
                key: 'txt_borgwaldt_1kg'
            }],
            'language': 'en',
            'languagesData': [],
            languageCodes: []
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleEPDBiasChange = this.handleEPDBiasChange.bind(this);
        this.savePreferences = this.savePreferences.bind(this);
        this.saveToDefaultPreferences = this.saveToDefaultPreferences.bind(this);
    }

    componentWillMount() {
        document.addEventListener("keydown", this.escFunction, false);
        CelaneseAPI.get(config.API.languageCodes).then(resp => {
            if (resp && resp.data) {
                this.setState({
                    languageCodes: resp.data
                });
            }
        });
        this.assignData(this.props);
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.escFunction, false);
    }

    /**
     * escFunction function is for closing the user preference window on pressing the escape key
     * @param {*} event here event is an event passed 
     * @memberof UserPreference
     */
    escFunction = (event) => {
        if (event.keyCode === 27) {
            this.props.setModalVisible(false);
        }
    }

    componentWillReceiveProps(nextProps) {

        if (this.props !== nextProps) {
            if (!nextProps.isModalVisible) {
                return;
            }
            this.assignData(nextProps);
            this.setState({
            }, function () {
                let preferenceData = nextProps.prefData && nextProps.prefData.preferences ? nextProps.prefData.preferences : '';
                let epdBiasName = this.state.epdBias || preferenceData.epdBias;
                let selEPDIdx = this.state.epdValues ? this.state.epdValues.findIndex(ele => ele.name === epdBiasName) : -1;
                if (preferenceData) {
                    preferenceData.kretek = (preferenceData.kretek === true || preferenceData.kretek === 1) ? 1 : 0;
                    preferenceData.pivmaxlim = parseInt(preferenceData.pivmaxlim, 10);
                    preferenceData.lowpdlim = parseInt(preferenceData.lowpdlim, 10);
                    preferenceData.epdSel = selEPDIdx;
                    this.setState(preferenceData);
                }
            });
        }


    }

    /**
     * assignData function is for getting the user preference data from redux/store
     * @param {object|array} nextProps
     * @memberof UserPreference
     */
    assignData(nextProps) {
        if (nextProps.epdData) {
            this.setState({
                epdValues: nextProps.epdData
            })
        }
        if (nextProps.prefData && nextProps.prefData.languages && JSON.stringify(nextProps.prefData.languages) !== JSON.stringify(this.state.languagesData)) {
            this.setState({
                languagesData: nextProps.prefData.languages
            });
        }
        if (nextProps.languagesData && nextProps.languagesData.length > 0) {
            let languagesHash = nextProps.languagesData.reduce((a, b) => { a[b.translationLanguage] = true; return a; }, {});
            let languages = Object.keys(languagesHash).map(item => {
                return {
                    translationLanguage: item,
                    languageCode: this.getLanguageByText(item)
                };
            });
            this.setState({
                languagesData: languages
            });
        }
    }

    getLanguageByText = (text, isCode) => {
        let fieldName = isCode ? 'code' : 'text';
        let finalFieldName = isCode ? 'text' : 'code';
        let languageCode = this.state.languageCodes.find(item => item[fieldName].toUpperCase() === text.toUpperCase());
        if (languageCode) {
            return languageCode[finalFieldName];
        } else {
            let closeLanguage = this.state.languageCodes.find(item => item[fieldName].toUpperCase().indexOf(text.toUpperCase()) === 0);
            return closeLanguage ? closeLanguage[finalFieldName] : text;
        }
    };

    handleEPDBiasChange(e) {
        let val = parseInt(e.target.value, 10);
        if (isNaN(val)) {
            this.setState({
                epdBias: '',
                epdBiasData: {},
                epdSel: -1
            });
            return;
        }
        let epdValue = this.state.epdValues[val];
        this.setState({
            epdBias: epdValue.name,
            epdBiasData: epdValue,
            epdSel: val
        });
    }

    /**
     * handleChange function keeping the values of the field in sync with what user selects
     * @param {*} e here e is an event passed 
     * @memberof UserPreference
     */
    handleChange(e) {
        let val = isNaN(e.target.value) ? e.target.value : parseInt(e.target.value, 10);
        this.setState({
            [e.target.name]: val
        });
    }

    /**
     * savePreferences function updates the database with the new preferences that the user has set
     * 
     * @memberof UserPreference
     */
    savePreferences() {
        let preferenceToUpdate = {
            size: this.state.size,
            epd: this.state.epd,
            weight: this.state.weight,
            pz: this.state.pz,
            rodMaker: this.state.rodMaker,
            transportJet: this.state.transportJet,
            firmnessMethod: this.state.firmnessMethod,
            epdBias: this.state.epdBias,
            epdBiasData: this.state.epdBias ? this.state.epdBiasData : {},
            towType: this.state.towType,
            kretek: this.state.kretek,
            pivmaxlim: this.state.pivmaxlim,
            lowpdlim: this.state.lowpdlim,
            language: this.state.language
        };
        this.setState({ isSaving: true });

        CelaneseAPI.post(config.API.preferences, preferenceToUpdate).then((res) => {
            if (!res.error) {
                this.setState({ isSaving: false });
                message.success( utils.getTranslationText ('msg_user_preference', 'User preferences saved successfully'), 2);
                this.props.setModalVisible(false);
                this.props.userPreferencesUpdated(preferenceToUpdate);
                getLocaleTranslationData(preferenceToUpdate.language);
            }
        });
    }

    /**
     * saveToDefaultPreferences function reverts the preferences to the default preferences of the user
     * @param {*} e here e is an event passed
     * @memberof UserPreference
     */
    saveToDefaultPreferences(e) {
        e.preventDefault();
        this.setState({
            ...preferenceState,
            language: this.props.prefData && this.props.prefData.preferences ? this.props.prefData.preferences.language : 'en'
        });        
    }
    render() {
        return (
            <div style={{ position: "absolute" }}>
                <Modal
                    title={<Translation labelName="title_user_preference" defaultText="User Preferences"/>}
                    centered
                    className='preferences'
                    width={800}
                    style={{ top: 20 }}
                    cancelText={<Translation labelName="btn_Reset_default" defaultText="Reset to Default"/>}
                    okText={<Translation labelName="btn_save" defaultText="Save"/>}
                    okButtonProps={
                        { loading: this.state.isSaving }
                    }
                    visible={this.props.isModalVisible}
                    onOk={() => this.savePreferences()}
                    onCancel={() => this.props.setModalVisible(false)}
                >
                    <div className="user-preference">
                        {/* <a href='/help/html/User_Preferences.htm' target="_blank" className="help-section">
                            <img
                                src="./images/help-inverse-black.svg"
                                alt="help"
                                className="help-icon" />
                        </a> */}
                        <div>
                            <div className="row">
                                <div className="col-sm-4">
                                    <div className="user-preference__row">
                                        <h3><Translation labelName="hdr_size_measure" defaultText="Size Measurement"/></h3>
                                        <div>
                                            <label>
                                                <input type="radio"
                                                    className="user-preference__radio-btn"
                                                    name="size"
                                                    value="1"
                                                    onChange={this.handleChange}
                                                    checked={this.state.size === 1 ? true : false} />
                                                <Translation labelName="lbl_circumference" defaultText="Circumference"/>
                                            </label>
                                        </div>
                                        <div>
                                            <label>
                                                <input type="radio"
                                                    className="user-preference__radio-btn"
                                                    name="size"
                                                    value="2"
                                                    onChange={this.handleChange}
                                                    checked={this.state.size === 2 ? true : false} />
                                                    <Translation labelName="lbl_diameter" defaultText="Diameter"/>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="user-preference__row">
                                        <h3><Translation labelName="hdr_pressure_drop" defaultText="Pressure Drop Unit"/></h3>
                                        <div>
                                            <label>
                                                <input type="radio"
                                                    name="lowpdlim"
                                                    value="1"
                                                    onChange={this.handleChange}
                                                    checked={this.state.lowpdlim === 1 ? true : false}
                                                />
                                               <Translation labelName="units_lbl_mm_H₂O" defaultText="mm H₂O"/>
                                            </label>
                                        </div>
                                        <div>
                                            <label>
                                                <input type="radio"
                                                    name="lowpdlim"
                                                    value="2"
                                                    onChange={this.handleChange}
                                                    checked={this.state.lowpdlim === 2 ? true : false} />
                                                <Translation labelName="units_pa" defaultText="Pa"/>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="user-preference__row">
                                        <h3><Translation labelName="hdr_weight_unit" defaultText="Weight Unit"/></h3>
                                        <div>
                                            <label>
                                                <input type="radio"
                                                    name="weight"
                                                    value="1"
                                                    onChange={this.handleChange}
                                                    checked={this.state.weight === 1 ? true : false}
                                                />
                                                <Translation labelName="units_g_100_rods" defaultText="g/100 rods"/>
                                            </label>
                                        </div>
                                        <div>
                                            <label>
                                                <input type="radio"
                                                    name="weight"
                                                    value="2"
                                                    onChange={this.handleChange}
                                                    checked={this.state.weight === 2 ? true : false}
                                                />
                                                <Translation labelName="units_mg_rod" defaultText="mg/rod"/>
                                            </label>
                                        </div>
                                        <div>
                                            <label>
                                                <input type="radio"
                                                    name="weight"
                                                    value="3"
                                                    onChange={this.handleChange}
                                                    checked={this.state.weight === 3 ? true : false}
                                                />
                                                <Translation labelName="units_g_rod" defaultText="g/rod"/>
                                            </label>
                                        </div>
                                    </div>
                                    {/* <div className="user-preference__row">
                                        <h3>Weight Basis</h3>
                                        <label>
                                            <input type="radio"
                                                name="pivmaxlim"
                                                value="1"
                                                onChange={this.handleChange}
                                                checked={this.state.pivmaxlim === 1 ? true : false}
                                            />
                                            Tow Only Weight
                                        </label>
                                        <label>
                                            <input type="radio"
                                                name="pivmaxlim"
                                                value="2"
                                                onChange={this.handleChange}
                                                checked={this.state.pivmaxlim === 2 ? true : false}
                                            />
                                            Wet Rod Weight
                                        </label>
                                    </div> */}
                                </div>
                                <div className="col-sm-4">
                                    <div className="user-preference__row">
                                        <h3><Translation labelName="hdr_plasticizer_calc" defaultText="Plasticizer Calculations"/></h3>
                                        <div>
                                            <label>
                                                <input type="radio"
                                                    name="pz"
                                                    value="1"
                                                    onChange={this.handleChange}
                                                    checked={this.state.pz === 1 ? true : false}
                                                />
                                              <Translation labelName="units_%" defaultText="%"/> <Translation labelName="lbl_dry_basis" defaultText="Dry"/>
                                            </label>
                                        </div>
                                        <div>
                                            <label>
                                                <input type="radio"
                                                    name="pz"
                                                    value="2"
                                                    onChange={this.handleChange}
                                                    checked={this.state.pz === 2 ? true : false}
                                                />
                                               <Translation labelName="units_%" defaultText="%"/> <Translation labelName="lbl_wet_basis" defaultText="Wet basis"/>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="user-preference__row">
                                        <h3><Translation labelName="hdr_rodmaker_speed" defaultText="RodMaker Speed"/></h3>
                                        <div>
                                            <label>
                                                <input type="radio"
                                                    name="rodMaker"
                                                    value="3"
                                                    onChange={this.handleChange}
                                                    checked={this.state.rodMaker === 3 ? true : false}
                                                />
                                                200 - 600 <Translation labelName="units_m_min" defaultText="m/min"/>
                                            </label>
                                        </div>
                                        <div>
                                            <label>
                                                <input type="radio"
                                                    name="rodMaker"
                                                    value="2"
                                                    onChange={this.handleChange}
                                                    checked={this.state.rodMaker === 2 ? true : false}
                                                />
                                                100 - 200 <Translation labelName="units_m_min" defaultText="m/min"/>
                                            </label>
                                        </div>
                                        <div>
                                            <label>
                                                <input type="radio"
                                                    name="rodMaker"
                                                    value="1"
                                                    onChange={this.handleChange}
                                                    checked={this.state.rodMaker === 1 ? true : false}
                                                />
                                                &lt; 100 <Translation labelName="units_m_min" defaultText="m/min"/>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="user-preference__row">
                                        <h3><Translation labelName="hdr_transport_jet" defaultText="Transport Jet"/></h3>
                                        <div>
                                            <label>
                                                <input type="radio"
                                                    name="transportJet"
                                                    value="3"
                                                    onChange={this.handleChange}
                                                    checked={this.state.transportJet === 3 ? true : false}
                                                />
                                               <Translation labelName="units_t_perf_funnel" defaultText="T.jet/Perf.Funnel"/>
                                            </label>
                                        </div>
                                        <div>
                                            <label>
                                                <input type="radio"
                                                    name="transportJet"
                                                    value="2"
                                                    onChange={this.handleChange}
                                                    checked={this.state.transportJet === 2 ? true : false}
                                                />
                                                <Translation labelName="units_t_jet_std_funnel" defaultText="T.jet/Std.Funnel"/>
                                            </label>
                                        </div>
                                        <div>
                                            <label>
                                                <input type="radio"
                                                    name="transportJet"
                                                    value="1"
                                                    onChange={this.handleChange}
                                                    checked={this.state.transportJet === 1 ? true : false}
                                                />
                                              <Translation labelName="units_std_funnel" defaultText="Std.Funnel"/>
                                            </label>
                                        </div>
                                    </div>
                                </div>   
                                <div className="col-sm-4">
                                    <div className="user-preference__row">
                                        <h3><Translation labelName="hdr_firmness_method" defaultText="Firmness Method"/></h3>
                                        <select value={this.state.firmnessMethod ? this.state.firmnessMethod : ''} name="firmnessMethod" onChange={this.handleChange}>
                                            {this.state.firmnessValues.length && (
                                                this.state.firmnessValues.map((val, i) => {
                                                    return (<option key={i} value={val.value}>{ utils.getTranslationText(val.key, val.value) }</option>);
                                                })
                                            )}
                                        </select>
                                    </div>
                                    <div className="user-preference__row">
                                        <h3><Translation labelName="lbl_epd_bias" defaultText="EPD Bias"/></h3>
                                        <select value={this.state.epdSel} name="epdBias" onChange={this.handleEPDBiasChange}>
                                            <Translation labelName="lbl_none" defaultText="None" isOption />
                                            {this.state.epdValues.length > 0 && (
                                                this.state.epdValues.map((val, i) => {
                                                    return (<option key={i} value={i}>{val.name}</option>);
                                                })
                                            )}
                                        </select>
                                    </div>
                                    <div className="user-preference__row">
                                        <h3><Translation labelName="hdr_kretek" defaultText="Kretek"/></h3>
                                        <div>
                                            <label>
                                                <input type="radio" name="kretek" value='0' onChange={this.handleChange} checked={this.state.kretek === 0 ? true : false} />
                                                <Translation labelName="lbl_off" defaultText="Off"/>
                                            </label>
                                        </div>
                                        <div>
                                            <label>
                                                <input type="radio" name="kretek" value='1' onChange={this.handleChange} checked={this.state.kretek === 1 ? true : false} />
                                               <Translation labelName="lbl_on" defaultText="On"/>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="user-preference__row">
                                        <h3><Translation labelName="hdr_language_chg" defaultText="Language"/></h3>
                                        <select value={this.state.language} name="language" onChange={this.handleChange}>
                                            {this.state.languagesData.length > 0 && (
                                                this.state.languagesData.map((val, i) => {
                                                    if (val.translationLanguage.toLowerCase() !== 'screen name') {
                                                        return (<option key={i} value={val.languageCode}>{ val.translationLanguage }</option>);
                                                    }
                                                    return null;
                                                })
                                            )}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a href='#' className='reset-preferences' onClick={(e) => this.saveToDefaultPreferences(e)}><Translation labelName="btn_Reset_default" defaultText="Reset to Default"/></a>
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = ({ loggedUserState, filtersState, languagesState }) => ({
    prefData: loggedUserState.prefData,
    epdData: filtersState.epdData,
    languagesData: languagesState.languagesData
});

const mapDispatchToProps = dispatch => ({
    userPreferencesUpdated: (data) => dispatch(userPreferencesUpdated(data))
})
export default connect(mapStateToProps, mapDispatchToProps)(UserPreference);

UserPreference.propTypes = {
    userPreferencesUpdated: PropTypes.func,
    prefData: PropTypes.object,
    languagesData: PropTypes.array,
    setModalVisible: PropTypes.func,
    isModalVisible: PropTypes.bool,
    prefObj: PropTypes.object,
    epdData: PropTypes.any
};


// WEBPACK FOOTER //
// ./src/components/global/UserPreference/index.js